import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import ResponsiveTooltip from '../ResponsiveTooltip';
import useMessageService from '../../services/i18n/useMessageService';
import LocalizedMessage from '../LocalizedMessage';

const SUPPORTED_SYMBOLS = `! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ \` { | } ~`;
const UNSUPPORTED_SYMBOLS = `é, ñ, ü`;

const propTypes = {
    show: PropTypes.bool,
};

const InvalidUsernameCharactersInlineMessage = ({ show = false }) => {
    const [
        [
            usernameInvalidCharacters = 'Enter a different email using {0}.',
            usernameValidCharactersTooltipText = 'valid characters',
            usernameInvalidCharactersTooltipContent = 'VeevaID usernames can only include letters, numbers, and supported symbols: {0}',
            usernameInvalidCharactersTooltipContextExample = 'Accented letters (like {0}) and other non-ASCII characters are not allowed.',
        ],
        messageLoading,
    ] = useMessageService([
        'register.self_register_invalid_characters_inline_error',
        'register.self_register_valid_characters_tooltip_text',
        'register.self_register_invalid_characters_tooltip_content',
        'register.self_register_invalid_characters_tooltip_content_examples',
    ]);

    if (!show || messageLoading) {
        return null;
    }

    const tooltipContent = (
        <>
            <div>
                <LocalizedMessage
                    key="supportedSymbolsParagraph"
                    template={usernameInvalidCharactersTooltipContent}
                    tokens={[SUPPORTED_SYMBOLS]}
                />
            </div>
            <div
                css={css`
                    margin-top: 1rem;
                `}
            >
                <LocalizedMessage
                    key="unsupportedSymbolsParagraph"
                    template={usernameInvalidCharactersTooltipContextExample}
                    tokens={[UNSUPPORTED_SYMBOLS]}
                />
            </div>
        </>
    );

    return (
        <div
            css={css`
                text-align: left;
            `}
        >
            <LocalizedMessage
                template={usernameInvalidCharacters}
                tokens={[
                    <ResponsiveTooltip key="invalidCharactersTooltip" content={tooltipContent}>
                        <span
                            css={css`
                                text-decoration: underline dotted;
                            `}
                        >
                            {usernameValidCharactersTooltipText}
                        </span>
                    </ResponsiveTooltip>,
                ]}
            />
        </div>
    );
};

InvalidUsernameCharactersInlineMessage.propTypes = propTypes;

export default InvalidUsernameCharactersInlineMessage;
